import type { FlagInstance } from '../../types.tsx';
import type { State } from '../types.tsx';

export const getFlags = (state: State): FlagInstance[] => state.flags;
